import { SearchModel, SearchResult } from './FindTravelAgentModule.types';
import ApiService from '@/common/ApiService/ApiService';
import { HttpVerb } from '@/common/ApiService/HttpVerb';

const travelAgentService = new ApiService('/api/TravelAgentsService/', {
  showLoading: false,
  cancel: true,
  returnData: true,
});

export const searchAgents = async (data: SearchModel): Promise<SearchResult> => {
  let result: SearchResult;
  result = await travelAgentService.call('SearchTravelAgents', data, {
    verb: HttpVerb.POST,
  });
  return result;
};
